import type { ProductData } from '@ori/analytics-data';
import type { GlobalProductQuerySignalsDto } from '@ori/global-api-client-react';

import type { SearchProduct } from '../components/SearchPreview/types';
import { PACKAGE_NAME } from '../constants-generated';
import { getSearchTime } from './getSearchTime';
import type { SearchPreviewResult } from './mapSearchPreviewQuery';

export interface FormatProductParams extends SearchProduct {
  currencyCode?: string;
}
export interface GetSignalsDataParams {
  customerId: number;
  position: number;
  results: SearchPreviewResult;
  timestamp: number;
  query: string;
}
export const analytics = {
  formatProduct: ({ name, brand, code, image, price, category, currencyCode }: FormatProductParams): ProductData => ({
    currency: currencyCode,
    globalBrandName: '',
    globalCategoryName: '',
    globalName: '',
    itemCode: code,
    localBrandName: brand ?? '',
    localCategoryName: category ?? '',
    localName: name,
    media: image ? [image] : [],
    price: price?.price,
  }),
  getSignalsData: ({
    customerId,
    position,
    results,
    timestamp,
    query,
  }: GetSignalsDataParams): GlobalProductQuerySignalsDto => ({
    params: {
      count: 1,
      docId: results.products[position]?.code,
      filterQueries: ['products'],
      position: position + 1,
      query,
      searchTime: getSearchTime(timestamp),
      source: PACKAGE_NAME,
      totalHits: results.numberOfProducts,
      userId: customerId.toString(),
    },
    timeStamp: new Date(),
    type: 'click',
  }),
};
